import { css } from "@emotion/react";

export const containerCss = css`
  display: flex;
  flex-direction: column;
  min-width: 180px;
`;

export const selectCss = css`
  background-color: #fff;
  border: 1px solid #ced4da;
  padding: 5px 15px;

  transition: border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Helvetica Neue, Arial, "sans-serif", Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
`;

export const inputCss = css`
  padding: 0.4em 1em;
  border-radius: 25px;
  border: 1px solid #ced4da;
  background: white;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;

  &:focus {
    outline: none;
  }
`;
